import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useStratifiedProductionChartsDataContext } from './hooks/useStratifiedProductionChartsDataContext';

export const ServicesByAge = () => {
    const { chartData } = useStratifiedProductionChartsDataContext();


    return (
        <SimpleBars
            title={'Atendimentos por Faixa Etária'}
            horizontal={false}
            subtitles={chartData?.servicesByAge?.map((item) => item.description)}
            values={chartData?.servicesByAge?.map((item) => item.total  ||  0)}
        />
    );
};
